var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-flex eu-ml_1 eu-px_4 eu-pb_4 gap_container" },
    [
      _c(
        "div",
        { staticClass: "eu-flex eu-width_100" },
        [
          _c("Bank", {
            attrs: {
              title: _vm.$t("charge.detail.payment-method.boleto.bank"),
              bank: _vm.lastTransaction.bank,
            },
          }),
          _vm.lastTransaction.due_at
            ? _c("DueAt", {
                attrs: {
                  title: _vm.$t("charge.detail.payment-method.boleto.due-at"),
                  dueAt: _vm.lastTransaction.due_at,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eu-flex eu-width_100" },
        [
          _c("BoletoDetail", {
            attrs: {
              "nosso-numero": _vm.lastTransaction.nosso_numero,
              "document-number": _vm.lastTransaction.document_number,
            },
          }),
        ],
        1
      ),
      _vm.isBusinessPsPOrHybrid
        ? _c(
            "div",
            { staticClass: "eu-flex eu-width_100 gap_penalty" },
            [
              _vm.lastTransaction.fine
                ? _c("BoletoFine", {
                    attrs: {
                      title: _vm.$t("charge.detail.payment-method.boleto.fine"),
                      type: _vm.boletoPenaltyEnum.FINE,
                      data: _vm.lastTransaction.fine,
                      amount: _vm.lastTransaction.amount,
                      dueAt: _vm.lastTransaction.due_at,
                    },
                  })
                : _vm._e(),
              _vm.lastTransaction.interest
                ? _c("BoletoInterest", {
                    attrs: {
                      title: _vm.$t(
                        "charge.detail.payment-method.boleto.interest"
                      ),
                      type: _vm.boletoPenaltyEnum.INTEREST,
                      data: _vm.lastTransaction.interest,
                      amount: _vm.lastTransaction.amount,
                      dueAt: _vm.lastTransaction.due_at,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "eu-flex eu-width_100" },
        [
          _vm.lastTransaction.line
            ? _c("BoletoLine", { attrs: { line: _vm.lastTransaction.line } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eu-flex eu-width_100" },
        [
          _vm.lastTransaction.url
            ? _c("BoletoUrl", { attrs: { url: _vm.lastTransaction.url } })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }